import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { USAEPAYAchPage } from './usaepay-ach.page';

const routes: Routes = [
  {
    path: '',
    component: USAEPAYAchPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class USAEPAYAchPageRoutingModule {}
